export default __webpack_public_path__ + "static/media/IMG-20241005-WA0010.0f5b9f7a.jpg";